import essApi from "../axios/essApi";

class GetUser {

    async getAllUserByRole(param) {
        return Promise.resolve(essApi.get(`users/getall-user/${param}`));
    }

    async getAssignedUserByManager(param) {
        return Promise.resolve(essApi.get(`users/userinfo-list-by-superiorId/${param}`));
    }

    async searchUsers(payload) {
        // console.log(payload, "payloadpayloadpayload")
        return Promise.resolve(essApi.post(`users/user-by-filter`, payload));
    }
    async addUsers(payload) {
        // console.log(payload, "payloadpayloadpayload")
        return Promise.resolve(essApi.post(`users/assign-manager`, payload));
    }
    async removeUsers(payload) {
        // console.log(payload, "payloadpayloadpayload")
        return Promise.resolve(essApi.post(`/users/unassign-manager`, payload));
    }

   
}

export default GetUser;

